import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.css'],
    standalone: false
})
export class DateTimePickerComponent implements OnInit {

  @Input() isSelectTime: boolean;
  @Input() displayDialog: boolean;
  @Input() maxFilterDate: Date;
  @Input() minFilterDate: Date;
  @Input() timeTo: String;
  @Input() timeFrom: String;
  @Input() top = 0;
  @Input() left = 0;
  @Output() onSubmit = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
    if (this.timeTo) this.selectCalendarFilterTo();
    if (this.timeFrom) this.selectCalendarFilterFrom();
  }

  selectCalendarFilterTo() {
    this.maxFilterDate = this.getDateFromString(this.timeTo);
  }

  selectCalendarFilterFrom() {
    this.minFilterDate = this.getDateFromString(this.timeFrom);
  }

  onClearAction() {
    this.timeFrom = undefined;
    this.timeTo = undefined;
    this.onSubmit.emit({"timeTo": this.timeTo, "timeFrom": this.timeFrom});
  }

  onOkAction() {
    this.onSubmit.emit({"timeTo": this.timeTo, "timeFrom": this.timeFrom});
  }

  //dd-mm-yyyy hh:mm to Date
  getDateFromString(dateString) {
    if (!dateString) return null;
    const [date, time] = dateString.split(" ");
    const [day, month, year] = date.split("-").map(Number);
    const [hour, minute] = time ? time.split(":").map(Number) : [0, 0];
    return new Date(year, month - 1, day, hour || 0, minute || 0);
  }

} 